<template>
  <div class="pageBox">
    <van-steps :active="active" @click-step="toStep" active-icon="success" active-color="#38f" style="font-weight: bold">
      <van-step>合作信息</van-step>
      <van-step>基本信息</van-step>
      <van-step>附件信息</van-step>
      <van-step>付款信息</van-step>
    </van-steps>
    <van-form ref="cooperationForm" validate-trigger="onSubmit" v-if="active == 0" class="contractForm">
      <van-cell title="合同类型：">
        <template>
          <van-radio-group v-model="form.contractType" direction="horizontal">
            <div v-for="(item,index) in radioOption.contractTypeOptions" :key="index">
              <van-radio :name="item.dictValue" clickable @click="form.contractType = item.dictValue">{{item.dictLabel}}</van-radio>
            </div>
          </van-radio-group>
        </template>
      </van-cell>
      <van-field readonly clickable v-model="form.companyName" @click="showPicker('company')" label="我方签约主体机构" :rules="[{ required: true }]" placeholder="请选择我方签约主体机构" required />
      <van-field readonly clickable v-model="form.bankAccountName" @click="form.companyName?showPicker('bankAccount'):''" label="付款银行账号" placeholder="请先选择我方签约主体机构" />
      <van-field readonly clickable v-model="form.deptName" label="我方签约部门" :rules="[{ required: true }]" placeholder="请选择我方签约部门" required @click="showCascader('dept')" />
      <van-field readonly clickable v-model="form.userName" label="我方签约人" placeholder="请选择我方签约人" :rules="[{ required: true }]" required @click="form.deptId?showPicker('userName'):''" />
      <van-field v-model="form.custName" @click="showCustList" label="供应商(乙方)" placeholder="请选择供应商(乙方)" readonly :rules="[{ required: true }]" required />
      <van-field v-model="form.percentage" v-if="form.contractType == 2" label="供应商返点" placeholder="请输入供应商返点" type="number" >
        <template slot="right-icon">%</template>
      </van-field>
      <van-cell style="color: #ff976a;" title="提示：供应商返点如果没有请填写 0" />
      <template v-if="form.contractType == 2">
        <!-- <van-field readonly clickable v-model="form.saleContractCustName" @click="showPicker('saleContractCustName')" label="项目名称" :rules="[{ required: true }]" placeholder="请选择项目名称" required v-if="saleContractCustOptions.length > 0" /> -->
        <van-field v-model="form.saleContractCustName" label="项目名称" placeholder="请输入项目名称" :rules="[{ required: true }]" />
      </template>
      <van-field v-model="form.businessTypeName" label="业务类型" placeholder="请选择业务类型" readonly :rules="[{ required: true }]" required @click="showCascader('businessType')" />
      <van-field v-model="form.saleContractName" v-if="form.contractType == 2" @click="showContractList" label="销售合同" placeholder="请选择销售合同" readonly :rules="[{ required: true }]" required />
      <van-field v-model="form.contractName" label="合同标题" placeholder="请先选择业务类型" readonly />
      <van-cell-group class="radioGroup">
        <van-cell title="审批流程类型：" >
          <template>
            <van-radio-group v-model="form.templateType" direction="horizontal" @change="radioChange">
              <div v-for="(item,index) in radioOption.templateTypeOptions" :key="index">
                <van-radio :name="item.dictValue" clickable @click="form.templateType = item.dictValue">{{item.dictLabel}}</van-radio>
              </div>
            </van-radio-group>
          </template>
        </van-cell>
        <van-cell style="color: #ff976a;" :title="'提示：1、用印指仅需要部门负责人审批；2、付款指需要财务审批确认。'" />
        <van-cell title="框架类型：">
          <template>
            <van-radio-group v-model="form.frameType" direction="horizontal" @change="frameTypeRadioChange">
              <div v-for="(item,index) in radioOption.frameTypeOptions" :key="index">
                <van-radio :name="item.dictValue" clickable @click="form.frameType = item.dictValue">{{item.dictLabel}}</van-radio>
              </div>
            </van-radio-group>
          </template>
        </van-cell>
        <van-cell title="付款方式：" v-if="form.frameType == 2">
          <template>
            <van-radio-group v-model="form.payType" direction="horizontal">
              <div v-for="(item,index) in radioOption.payTypeOptions.slice(1, radioOption.payTypeOptions.length)" :key="index">
                <van-radio :name="item.dictValue" clickable @click="form.payType = item.dictValue">{{item.dictLabel}}</van-radio>
              </div>
            </van-radio-group>
          </template>
        </van-cell>
      </van-cell-group>
    </van-form>
    <van-form ref="basicsForm" validate-trigger="onSubmit" class="" v-if="active == 1">
      <van-field v-model="form.executionTime" readonly clickable name="calendar" label="合同执行时间" placeholder="点击选择合同执行时间" @click="showCalendar('executionTime')" required />
      <van-field v-model="form.contractMoney" label="合同总金额" placeholder="请输入合同金额" @blur="getSum('contractMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
      <van-cell style="color: #1989fa;" :title="amountWords" />
      <van-field v-model="form.invoicingMethodName" label="开票方式" placeholder="请选择开票方式" readonly clickable  @click="showPicker('invoicingMethod')" />
      <van-field v-model="form.invoiceTypeName" label="发票类型" placeholder="请选择发票类型" readonly clickable  @click="showPicker('invoiceType')" />
      <van-field v-model="form.signedUser" label="对方签约人" placeholder="请输入对方签约人" :rules="[{ required: true }]" required />
      <van-field v-model="form.signedUserMobile" label="对方电话" placeholder="请输入对方签约人电话" :rules="[
                { required: true, message: '请输入对方签约人电话' },
                { pattern: /^[0-9-]+$/g, message: '手机或电话号码格式错误！'}
              ]" required />
      <van-field v-model="form.signedUserEmail" label="对方邮箱" placeholder="请输入对方签约人邮箱" />
      <van-field v-model="form.signedUserWx" label="对方微信" placeholder="请输入对方签约人微信号" />
      <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约时间" placeholder="点击选择签约时间" @click="showCalendar('signTime')" :rules="[{ required: true }]" required />
      <van-field v-model="form.deliveryTime" readonly clickable name="calendar" label="交付日期" placeholder="点击选择交付日期" @click="showCalendar('deliveryTime')" />
      <van-field v-model="form.content" rows="2" autosize label="内容摘要" placeholder="请输入内容摘要" type="textarea" show-word-limit />
    </van-form>

    <van-form ref="contactForm" validate-trigger="onSubmit" class="" v-if="active == 2">
      <van-cell style="color: #ff976a;" title="提示信息：审批流程类型为采购支付时，必须在合同附件中上传合同附件和供应商发票，否则不能提交审批" />
      <van-button v-if="form.fileList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addEnclosure">+增加附件</van-button>
      <van-collapse v-model="activeNamesC">
        <van-collapse-item :title="'附件'+(index+1)" :name="index" v-for="(item,index) in form.fileList" :key="index+'01'">
          <!-- <van-field v-model="item.title" label="附件标题" placeholder="请输入附件标题" :rules="[{ required: true }]" required /> -->
          <!-- <van-field v-model="item.amount" label="变动金额(元)" placeholder="请输入变动金额" @focus="getFocus(index)" @blur="getSum('amount',index)" type="number" maxlength="11" /> -->
          <van-field v-model="item.fileTypeName" label="附件类型" placeholder="请选择附件类型" readonly clickable  @click="showPicker('fileType',index)" :rules="[{ required: true }]" required />
          <van-cell v-if="item.fileType" style="color: #ff976a;" :title="item.fileType == 10 ? '请上传格式为png,jpg,jpeg的图片' : '请上传格式为pdf,word的文件'" />
          <van-field
            v-model="item.fileDesc"
            rows="2"
            autosize
            label="附件描述"
            placeholder="请输入附件描述"
            type="textarea"
            show-word-limit
          />
          <van-field v-model="item.url" label="上传附件" placeholder="需要上传的文件" readonly @click="getIndex(index)" :rules="[{ required: true }]" required >
            <template #button>
              <van-uploader :after-read="uploadContractPictureFiles" :before-read="beforeRead" :max-size="10000 * 1024" @oversize="onOversize" accept="application/pdf,.doc,.docx,.png,.jpg,.jpeg">
                <van-button icon="plus" type="info" size="mini"></van-button>
              </van-uploader>
              <van-button round size="mini" color="#ee0a24" native-type="button" @click="viewFileTip" style="margin-left: 10px;padding: 0 7px;font-size: 14px">?</van-button>
            </template>
          </van-field>
          <div class="attachment_link">
            <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">{{item.fileName}}    查看附件</a>
          </div>
          <!-- <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">查看附件</a> -->
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addEnclosure">+增加附件</van-button>
            <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteE(index)">删除</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-form>
    <van-form ref="payAgreeForm" validate-trigger="onSubmit" class="" v-if="active == 3">
      <van-button v-if="form.contPayAgreeList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addPayment">+增加付款信息</van-button>
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="'付款信息'+(index+1)" :name="index" v-for="(item,index) in form.contPayAgreeList" :key="index+'01'">
          <van-field v-model="item.openName" label="开户名" placeholder="请输入开户名" :rules="[{ required: true }]" required />
          <van-field v-model="item.openRow" label="开户行" placeholder="请输入开户行" :rules="[{ required: true }]" required />
          <van-field v-model="item.companyAccount" label="公司账号" placeholder="请输入公司账号" :rules="[{ required: true }]" required />
          <van-field v-model="item.advancesMoney" label="付款金额(元)" placeholder="请输入付款金额" @focus="getFocus(index)" @blur="getSum('advancesMoney',index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
          <van-field v-model="item.payTime" readonly clickable name="calendar" label="预付款日期" placeholder="点击选择预付款日期" @click="showCalendar('payTime',index)" :rules="[{ required: true }]" required />
          <!-- <van-field
            v-model="item.remark"
            rows="2"
            autosize
            label="备注"
            placeholder="请输入备注"
            type="textarea"
            show-word-limit
          /> -->
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPayment">+增加付款信息</van-button>
            <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteT(index)">删除</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-form>
    <div class="bottomBtn" >
      <!-- <div class="remark" v-if="(contractNumCount || contractNumCount === 0)">当前可使用合同编号数量：{{contractNumCount}}份</div> -->
      <div class="btnGroup">
        <van-button style="flex: 0.3" v-if="active != 0" class="addBtn" round block type="primary" native-type="button" size="small" @click="backStep">上一步</van-button>
        <van-button style="flex: 0.3" class="addBtn" round block type="info" native-type="button" size="small"  @click="nextStep">{{active == 0?'下一步':active == 3?'保存':'保存下一步'}}</van-button>
        <!-- <van-button style="flex: 0.3" v-if="active == 3" class="addBtn" round block color="#ee0a24" native-type="button" size="small" @click="closeGo">关闭</van-button> -->
        <!-- v-preventReClick -->
      </div>
    </div>

    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" :field-names="tree.fieldNames" @change="treeChange" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="dateConfirm" />
    <select-customer :show='selectCustshow' @handleCancel='handleCancel' @beforeClose='selectBeforeClose'></select-customer>
    <select-contract :show='selectContshow' @handleCancel='handleContCancel' @beforeClose='selectContBeforeClose'></select-contract>
    <van-popup v-model="mediaSelect" position="bottom">
      <van-tree-select :items="treeItems" :active-id.sync="mediaActiveIds" :main-active-index.sync="treeActiveIndex" @click-item="chooseTree" />
      <van-button block type="info" native-type="button" size="small" @click="mediaSelect = false">完成</van-button>
    </van-popup>
    <van-popup v-model="deliverySelect" position="bottom">
      <van-tree-select :items="treeItems" :active-id.sync="deliveryActiveIds" :main-active-index.sync="treeActiveIndex" @click-item="chooseTree" />
      <van-button block type="info" native-type="button" size="small" @click="deliverySelect = false">完成</van-button>
    </van-popup>
    <dialog-add :show='add_show' :modifyObj="customer" :isAdd='true' @handleAddBoCancel='handleAddBoCancel' @beforeClose='addBoBeforeClose' ></dialog-add>
    <van-dialog v-model="showFileTip" title="附件选择文件说明" width='80%' confirmButtonText="关闭">
      <div class="file_tip">
        <div>IOS手机选择文件：</div>
        第一步，打开微信，点击需要保存的文件。
        第二步，进入该文件后，点击更多图标。
        第三步， 在菜单栏内选择“用其他应用打开”。
        第四步，选择“存储到“文件””。
        第五步，此时已经进入了“iCloud 云盘”，选择希望存储在的文件夹内即可。此例选择存入“文本编辑”。
        这样，微信内的文件就存储在了iOS系统的“文件”app内了。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getUser } from '@/api/system/user'
import newContract from '@/api/cont/newContract'
import purchase from '@/api/cont/purchase'
import payment from '@/api/cont/payment'
import { getDicts } from '@/api/system/dict/data'
import { Toast, Tag, Cascader, TreeSelect, Dialog, NoticeBar } from 'vant'
import { CascaderTreeSelect, companyList, treeselect } from '@/api/admi/dept'
import { selectDeptIdByUserList } from '@/api/admi/user'
import SelectCustomer from './components/SelectCustomer'
import SelectContract from '@/views/cont/components/SelectContract'
import DialogAdd from '@/views/scrm/component/DialogAddBo.vue'

export default {
  name: 'contractAdd',
  components: {
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    [TreeSelect.name]: TreeSelect,
    [Dialog.Component.name]: Dialog.Component,
    [NoticeBar.name]: NoticeBar,
    vanCascader: Cascader,
    SelectCustomer,
    SelectContract,
    DialogAdd
  },
  data() {
    return {
      index: null,
      active: 0,
      isFixed: false, // 是否修改
      isZfcq: false, // 是否作废重签
      isVendite: false, // 是否是 销售/数字技术类
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      add_show: false,
      showDept: false,
      deptList: [],
      serviceTypeTreeList: [],
      deptUserList: [],
      custBoList: [],
      deptTreeList: [],
      contractNumCount: '0',
      amountWords: '',
      pointList: [],
      form: {
        contractType: 2,
        userName: '',
        userId: '',
        useSealTime: null,
        templateType: '1',
        frameType: '1',
        payType: '6',
        // custSource: '1',
        payCycle: '',
        startTime: '',
        endTime: '',
        deptName: '',
        deptId: '',
        custName: '',
        custId: '',
        cooperationPolicy: '',
        contractName: '',
        contractMoney: '',
        contractId: null,
        content: '',
        isAuth: '0',
        contPayAgreeList: [
          // {
          //   contractId: null,
          //   contPayType: '',
          //   payTime: '',
          //   payCondition: '',
          //   contractMoney: '',
          //   companyName: '',
          //   companyId: '',
          //   custName: '',
          //   custId: '',
          //   entrustCustName: '',
          //   entrustCustId: ''
          // }
        ],
        fileList: [
          // {
          //   contractId: null,
          //   title: '',
          //   amount: '',
          //   fileType: '',
          //   fileDesc: '',
          //   url: ''
          // }
        ],
        companyName: '',
        companyId: '',
        bankAccountId: '', // 收款银行账号
        bankAccountName: '',
        businessTypeName: '',
        businessTypeId: '',
        boName: '',
        boId: '',
        signedMainType: '',
        mediaType: '',
        operationMode: '',
        invoicingMethod: '',
        invoiceType: '',
        creditMoney: null, // 授信金额
        creditCycleValue: null, // 授信账期时间
        creditCycleType: null, // 授信账期类型：1 自然日 2 工作日 3 自然月
        advancesCycle: null, // 垫款事由
        collectionPeriod: null, // 回款账期(天)

        saleContractId: null,
        saleContractName: null,
        saleContractCustName: null
      },
      saleContractCustOptions: [],
      payBankList: [], // 收款银行列表
      selectCustshow: false,
      selectContshow: false,
      radioOption: {
        templateTypeOptions: [],
        frameTypeOptions: [],
        custSourceOptions: [],
        payTypeOptions: [],
        contractTypeOptions: [{ dictLabel: '业务合同', dictValue: 2 }, { dictLabel: '行政合同', dictValue: 3 }]
      },
      options: {
        mediaTypeOptions: [],
        cooperationPolicyOptions: [],
        operationModeOptions: [],
        invoicingMethodOptions: [],
        invoiceTypeOptions: [],
        signedMainTypeOptions: [],
        contPayTypeOptions: [],
        fileTypeOptions: [],
        mediaLocationOptions: [],
        deliveryLinkOptions: []
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2042, 11, 31),
        type: 'single',
        formKey: ''
      },
      mediaSelect: false,
      deliverySelect: false,
      typeTree: '',
      treeActiveIndex: 0,
      mediaActiveIds: [],
      deliveryActiveIds: [],
      treeItems: [],
      executionTime: '', // 执行时间
      activeNames: [0],
      activeNamesC: [0],
      activeNamesP: [0],
      customer: {},
      showFileTip: false
    }
  },
  async created() {
    if (this.$route.query.isZfcq) {
      this.isZfcq = this.$route.query.isZfcq
    }
    if (this.$route.query.customer) {
      this.customer = JSON.parse(this.$route.query.customer)
    }
    await this.getRadioOptions()
    this.form.deptId = this.$store.state.user.user.deptId
    await treeselect().then((response) => {
      const dept = this.getParent(response.data, this.form.deptId)
      dept.map((item) => {
        this.form.deptName += item.label + '/'
      })
      this.form.deptName = this.form.deptName.substring(0, this.form.deptName.length - 1)
    })
    this.form.userName = this.$store.state.user.user.nickName
    this.form.userId = this.$store.state.user.user.userId
    console.log(this.radioOption)
    // this.getTagList()
    if (this.$route.query.contractId) {
      this.getOptions()
      // this.active = 1
      this.isFixed = true
      await this.getContract(this.$route.query.contractId)
      await this.getListPoint(this.$route.query.contractId)
      await this.getListContractFile(this.$route.query.contractId)
      await this.getListPayAgree(this.$route.query.contractId)
    }

    // 商业页面跳转
    if (this.$route.query.boName) {
      this.form = { ...this.form, ...this.$route.query }
      this.form.contractName = this.$route.query.boName
      this.form.userName = this.$route.query.userName
      const name = this.form.businessTypeName.split('/')
      if (name[0] == '销售' && name[1] == '数字技术类') {
        this.isVendite = false
      } else {
        this.isVendite = true
      }
      const res = await getUser(this.$route.query.userId)
      if (res.code === 200) {
        // this.form.deptName = res.data.deptName
        this.form.deptId = res.data.dept.deptId
      }
      await treeselect().then((response) => {
        const dept = this.getParent(response.data, this.form.deptId)
        dept.map((item) => {
          this.form.deptName += item.label + '/'
        })
        this.form.deptName = this.form.deptName.substring(0, this.form.deptName.length - 1)
      })
      await companyList().then((response) => {
        this.form.companyName = response.rows[0].companyName
        this.form.companyId = response.rows[0].companyId
      })
      // await this.getContCount()
      console.log(this.form)
    }
  },
  mounted() {
    this.init()
    payment.listPayBank({ companyId: this.$route.query.companyId }).then(res => {
      if (res.code === 200 && res.rows.length > 0) {
        this.payBankList = res.rows
      }
    })
  },
  methods: {
    radioChange() {
      // if (this.form.templateType != 2) {
      // if (this.form.businessTypeId) {
      //   this.getContCount()
      // }
      // }
    },
    formBankAccount(name, val) {
      const ele = this.payBankList.find(res => { return res.bankAccountId == val })
      return `${ele.bankName}(${ele.accountNum})`
    },
    fixValue(val, index) {
      if (index == 1) {
        this.pointList[0].useMoney = val
      }
      if (Number(val) < Number(this.pointList[index - 1].useMoney)) {
        Toast.fail('当前金额不能小于上一个金额')
        this.pointList[index].useMoney = ''
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getParent(data2, nodeId2) {
      var arrRes = []
      if (data2.length == 0) {
        if (nodeId2) {
          arrRes.unshift(data2)
        }
        return arrRes
      }
      const rev = (data, nodeId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          const node = data[i]
          if (node.id == nodeId) {
            arrRes.unshift(node)
            rev(data2, node.parentId)
            break
          } else {
            if (node.children) {
              rev(node.children, nodeId)
            }
          }
        }
        return arrRes
      }
      arrRes = rev(data2, nodeId2)
      return arrRes
    },
    async getContract(contractId) {
      const res = await purchase.getSaleContract(contractId)
      if (res.code === 200) {
        this.form = res.data
        if (this.form.remark == '作废重签') {
          this.isZfcq = true
        }
        this.form.contractType = Number(this.form.contractType)
        this.form.payType = this.form.payType ? this.form.payType.toString() : null
        this.form.frameType = this.form.frameType.toString()
        this.form.templateType = this.form.templateType.toString()
        this.form.executionTime = `${this.form.startTime} 至 ${this.form.endTime}`
        this.form.invoicingMethodName = this.formatHandel('invoicingMethod', this.form.invoicingMethod)
        this.form.invoiceTypeName = this.formatHandel('invoiceType', this.form.invoiceType)
        this.amountWords = this.toChineseBig(this.form.contractMoney)
        // this.form.bankAccountName = this.formBankAccount('bankAccountId', this.form.bankAccountId)
        if (this.form.custSource && this.form.custSource == '2') {
          purchase.getSaleContractCustName({ contractId: this.form.saleContractId }).then(res => {
            if (res.code == 200) {
              this.saleContractCustOptions = res.data
            } else {
              Toast.fail(res.msg)
            }
          })
        }
      }
    },
    async getListPoint(contractId) {
      const res = await newContract.getRebateList({ contractId: contractId })
      if (res.code === 200) {
        if (res.rows.length != 0) {
          this.pointList = res.rows
          this.pointList.map(item => {
            item.zxTime = `${item.startTime} 至 ${item.endTime}`
          })
        }
      }
    },
    async getListContractFile(contractId) {
      const res = await newContract.listContractFile({ contractId })
      const that = this
      if (res.code === 200) {
        if (res.rows.length != 0) {
          this.form.fileList = res.rows
          await that.form.fileList.forEach(function(value, index, array) {
            that.form.fileList[index].fileTypeName = that.formatHandel('fileType', Number(that.form.fileList[index].fileType))
          })
        }
      }
    },
    async getListPayAgree(contractId) {
      const res = await purchase.listSaleAgree({ contractId })
      const that = this
      if (res.code === 200) {
        console.log(res.rows)
        if (res.rows.length != 0) {
          this.form.contPayAgreeList = res.rows
          await that.form.contPayAgreeList.forEach(function(value, index, array) {
            that.form.contPayAgreeList[index].contPayTypeName = that.formatHandel('contPayType', Number(that.form.contPayAgreeList[index].contPayType))
          })
        }
      }
    },
    frameTypeRadioChange() {
      if (this.form.frameType == 2) {
        // if (this.form.businessTypeId) {
        //   this.getContCount()
        // }
        this.form.payType = '7'
      } else {
        this.form.payType = '6'
      }
    },
    async getContCount() {
      const res = await purchase.getContractNumCount(this.form)
      if (res.code === 200) {
        this.contractNumCount = res.data
      } else {
        this.contractNumCount = 0
      }
    },
    getRadioOptions() {
      // 合同模板
      getDicts('cont_buy_approve_flow_type').then(res => {
        this.radioOption.templateTypeOptions = res.data
      })
      // 框架类型
      getDicts('frame_type').then(res => {
        this.radioOption.frameTypeOptions = res.data
      })
      // 客户来源类型
      getDicts('cust_source').then(res => {
        this.radioOption.custSourceOptions = res.data
      })
      // 垫款方式
      getDicts('buy_pay_type').then(res => {
        this.radioOption.payTypeOptions = res.data
      })
      // 付款类型
      getDicts('cont_pay_type').then(res => {
        this.options.contPayTypeOptions = res.data
      })
      // 附件类型
      getDicts('file_type').then(res => {
        this.options.fileTypeOptions = res.data
      })
      // 授信账期类型
      getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
    },
    getOptions() {
      // 媒介归属
      getDicts('media_type').then(res => {
        this.options.mediaTypeOptions = res.data
      })
      // 合作政策
      getDicts('cooperation_policy').then(res => {
        this.options.cooperationPolicyOptions = res.data
      })
      // 运营方式
      getDicts('operation_mode').then(res => {
        this.options.operationModeOptions = res.data
      })
      // 开票方式
      getDicts('Invoicing_method').then(res => {
        this.options.invoicingMethodOptions = res.data
      })
      // 发票类型
      getDicts('Invoice_type').then(res => {
        this.options.invoiceTypeOptions = res.data
      })
      // 我方主体地址
      getDicts('signed_main_type').then(res => {
        this.options.signedMainTypeOptions = res.data
      })
    },
    // 打开联级选择框
    async showCascader(val) {
      if (val === 'dept' || val === 'infoDept') {
        if (this.deptTreeList.length == 0) {
          await CascaderTreeSelect().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {}
        }
      } else if (val === 'businessType') {
        if (this.serviceTypeTreeList.length == 0) {
          await purchase.selectAllBusinessTypePurchase().then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.handleTree(response.data, 'businessTypeId')
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.serviceTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.form.deptId = obj.value
        this.form.deptName = obj.selectedOptions.map((option) => option.text).join('/')
        // if (this.form.businessTypeId && this.form.companyId && this.form.userId) {
        //   this.getContCount()
        // }
      } else if (this.tree.type === 'infoDept') {
        this.form.infoDeptId = obj.value
        this.form.infoDeptName = obj.selectedOptions.map((option) => option.text).join('/')
      }
    },
    onFinishTree(obj) {
      if (this.tree.type === 'businessType') {
        this.form.businessTypeId = obj.value
        this.form.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
        this.form.businessTypeName = '采购/' + this.form.businessTypeName
        if (this.form.custName) {
          this.form.contractName = `${this.form.custName}【${this.form.businessTypeName}】`
        }
        // if (this.form.deptId && this.form.companyId && this.form.userId) {
        //   this.getContCount()
        // }
      }
      this.tree.typeTree = false
    },
    backStep() {
      if (this.active == 0) {

      } else {
        this.active--
      }
    },
    // 下一步
    async nextStep() {
      // await this.$refs["form"].validate()
      // if(this.active == 4){
      //   this.form.contPayAgreeList[0].companyName = this.form.companyName
      //   this.form.contPayAgreeList[0].companyId = this.form.companyId
      //   this.form.contPayAgreeList[0].custName =this.form.custName
      //   this.form.contPayAgreeList[0].custId = this.form.custId
      //   return
      // }else{
      //   // this.active++
      //   if(this.active == 1){
      //     this.getOptions()
      //   }
      // }
      switch (this.active) {
        case 0:
          await this.$refs.cooperationForm.validate()
          // if (this.contractNumCount == 0 && !this.form.contractId) {
          //   Toast.fail('该类模板合同已无库存，请事业部合同管理员联系行政领取。')
          //   return
          // } else {
          if (!this.form.signedUser && !this.form.signedUserMobile) {
            const res = await newContract.getContacts({ custId: this.form.custId })
            if (res.code === 200) {
              if (res.data.length > 0) {
                this.form.signedUser = res.data[0].contactName
                this.form.signedUserMobile = res.data[0].mobile
                this.form.signedUserWx = res.data[0].weixinSn
                this.form.signedUserEmail = res.data[0].email
              }
            } else {
              Toast.fail(res.msg)
            }
          }
          await this.active++
          // }
          this.getOptions()
          break
        case 1:
          if (this.form.payType == '1') {
            this.form.creditMoney = null // 授信金额
            this.form.creditCycleValue = null // 授信账期时间
            this.form.creditCycleType = null // 授信账期类型：1 自然日 2 工作日 3 自然月
            // this.form.advancesCycle = null // 垫款事由
            this.form.collectionPeriod = null // 回款账期(天)
            this.form.creditTotalMoney = null
            this.form.advancesProject = null
            this.form.advancesMoney = null
          }
          if (this.form.frameType == 1 && this.form.contractMoney <= 0) {
            Toast.fail('合同金额必须大于0')
            return
          }

          this.$refs.basicsForm.validate().then(() => {
            if (!this.form.contractId) {
              purchase.addSaleContract(this.form).then((res) => {
                if (res.code === 200) {
                  this.form.contractId = res.data.contractId
                  Toast.success('新增成功')
                  this.getListPoint(this.form.contractId)
                  this.active++
                } else {
                  Toast.fail(res.msg)
                }
              })
            } else {
              purchase.updateSaleContract(this.form).then((res) => {
                if (res.code === 200) {
                  Toast.success('修改成功')
                  this.active++
                } else {
                  Toast.fail(res.msg)
                }
              })
            }
          }).catch(() => {
            const isError = document.getElementsByClassName('van-field--error') // 适用于vant
            isError[0].querySelector('.van-field__control').focus() // 只定位到第一个必填项位置
          })
          break
        case 2:
          await this.$refs.contactForm.validate()
          if (this.form.fileList.length != 0) {
            const res2 = await newContract.addContractFile(this.form.fileList)
            if (res2.code === 200) {
              await Toast.success('操作成功')
              this.active++
            } else {
              Toast.fail(res2.msg)
            }
          } else {
            Toast.fail('上传附件后才能执行后续操作')
            this.active++
          }
          break
        case 3:
        {
          // if (this.form.contPayAgreeList.length == 0) {
          //   Toast.fail('付款信息不能为空')
          //   return
          // }
          if (this.form.templateType && this.form.contPayAgreeList.length == 0) {
            Toast.fail('审批流程类型为采购支付时付款信息不能为空')
            return
          }
          if (this.form.contPayAgreeList.length > 0) {
            await this.$refs.payAgreeForm.validate()
            // if (this.form.contPayAgreeList.length != 0) {
            const res3 = await purchase.addSaleAgree(this.form.contPayAgreeList)
            if (res3.code === 200) {
              await Toast.success('操作成功')
            } else {
              Toast.fail(res3.msg)
            }
          }
          setTimeout(() => {
            this.closeGo()
          }, 500)
          // } else {
          //   setTimeout(() => {
          //     this.closeGo()
          //   }, 500)
          // }
          break }
      }
    },
    closeGo() {
      if (this.form.fileList.length == 0) {
        Toast.fail('请先上传附件')
        return
      }
      Dialog.confirm({
        // title: '提示',
        message: '是否立即提交审批申请',
        confirmButtonText: '提交审批',
        confirmButtonColor: '#1989fa',
        cancelButtonText: '保存草稿'
      })
        .then(() => {
          // on confirm
          purchase.spApply({ contractId: this.form.contractId }).then((res) => {
            if (res.code === 200) {
              Toast.success('审批申请成功!')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
          // on cancel
          this.$router.go(-1)
        })
    },
    toStep(index) {
      // if (index == 4) {
      //   this.form.contPayAgreeList[0].companyName = this.form.companyName
      //   this.form.contPayAgreeList[0].companyId = this.form.companyId
      //   this.form.contPayAgreeList[0].custName = this.form.custName
      //   this.form.contPayAgreeList[0].custId = this.form.custId
      // }
      if (this.$route.query.contractId) {
        this.active = index
      } else {
        if (this.active == 0 || index == 0 || this.active == 1 || this.active == 2) {

        } else {
          this.active = index
        }
      }
    },
    async init() {
      // 修改主体框架标题
      document.title = '新建采购合同'
    },
    getFocus(index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
    },
    getSum(val) {
      if (this.index || this.index == 0) {
        if (val === 'advancesMoney' && this.form.contPayAgreeList[this.index][val].indexOf('.') != -1) {
          this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        }
        if (val === 'amount' && this.form.fileList[this.index][val].indexOf('.') != -1) {
          this.form.fileList[this.index][val] = Number(this.form.fileList[this.index][val]).toFixed(2)
        }
        // if (this.form.fileList[this.index][val].indexOf('.') != -1) {
        //   this.form.fileList[this.index][val] = Number(this.form.fileList[this.index][val]).toFixed(2)
        // } else {
        //   this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        // }
      } else {
        if (this.form[val].indexOf('.') != -1) {
          this.form[val] = Number(this.form[val]).toFixed(2)
        }
        this.amountWords = this.toChineseBig(this.form.contractMoney)
      }

      // let contractMoeny = this.form.contractMoney || 0;
      // let allReturnedMoney = this.form.allReturnedMoney || 0;
      // let total = contractMoeny - allReturnedMoney
      // this.form.noReturnedMoney = total.toFixed(2);
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'company') {
        // 获取公司信息
        if (this.deptList.length == 0) {
          await companyList().then((response) => {
            this.deptList = response.rows
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type === 'userName') {
        // 选择人员
        selectDeptIdByUserList(this.form.deptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else if (type === 'infoUserName') {
        selectDeptIdByUserList(this.form.infoDeptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else if (type === 'boId') {
        // 选择商机
        newContract.getBoListByUserId({ userId: this.form.userId }).then(response => {
          this.custBoList = response.rows
          this.picker.columns = this.custBoList.map(item => item.boName + '(' + item.custName + ')')
          this.picker.loading = false
        })
      } else if (type === 'bankAccount') {
        await payment.listPayBank({ companyId: this.form.companyId }).then(res => {
          if (res.code === 200) {
            this.payBankList = res.rows
          }
        })
        this.payBankList.forEach((ele) => {
          ele.incomeBankName = `${ele.bankName}(${ele.accountNum})`
        })
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else if (type == 'saleContractCustName') {
        this.picker.columns = this.saleContractCustOptions.map((ele) => ele.execCustomerName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'fileType') {
          this.form.fileList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.fileList[this.index][name] = this.options[optionItem][key].dictLabel
        } else {
          this.form.contPayAgreeList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.contPayAgreeList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'company') {
          this.form.companyName = this.deptList[key].companyName
          this.form.companyId = this.deptList[key].companyId
          // if (this.form.businessTypeId && this.form.deptId && this.form.userId) {
          //   this.getContCount()
          // }
          await payment.listPayBank({ companyId: this.form.companyId }).then(res => {
            if (res.code === 200 && res.rows.length > 0) {
              const ele = res.rows.find(res => { return res.isSelect == 1 })
              this.form.bankAccountId = ele.bankAccountId
              this.form.bankAccountName = `${ele.bankName}(${ele.accountNum})`
            }
          })
        } else if (this.picker.formKey === 'boId') {
          this.form.boId = this.custBoList[key].boId
          this.form.boName = this.custBoList[key].boName
          this.form.custId = this.custBoList[key].custId
          this.form.custName = this.custBoList[key].custName
          this.form.contractName = this.custBoList[key].boName
          this.form.businessTypeName = this.custBoList[key].businessTypeName
          this.form.businessTypeId = this.custBoList[key].businessTypeId
          const name = this.form.businessTypeName.split('/')
          if (name[0] == '销售' && name[1] == '数字技术类') {
            this.isVendite = false
            this.form.frameType = '1'
            this.form.payType = '1'
            this.form.custSource = null
            this.form.payCycle = null
            // this.form.advancesCycle=null
            this.form.creditCycleType = null
            this.form.creditCycleValue = null
            this.form.collectionPeriod = null
            this.form.creditMoney = null
            this.form.mediaType = null
            this.form.cooperationPolicy = null
            this.form.operationMode = null
          } else {
            this.isVendite = true
            this.form.custSource = '1'
          }
          if (name[0] != '销售') {
            // this.isMarketing=true
          }
          // this.getContCount()
        } else if (this.picker.formKey === 'userName') {
          // this.form.nickName = this.deptUserList[key].nickName
          this.form.userName = this.deptUserList[key].nickName
          this.form.userId = this.deptUserList[key].userId
          // if (this.form.businessTypeId && this.form.deptId && this.form.companyId) {
          //   this.getContCount()
          // }
        } else if (this.picker.formKey === 'infoUserName') {
          // this.form.nickName = this.deptUserList[key].nickName
          this.form.infoUserName = this.deptUserList[key].nickName
          this.form.infoUserId = this.deptUserList[key].userId
        } else if (this.picker.formKey === 'bankAccount') {
          // this.form.incomeBankName = this.payBankList[key].incomeBankName
          // this.form.incomeBankId = this.payBankList[key].bankAccountId
          this.form.bankAccountId = this.payBankList[key].bankAccountId
          this.form.bankAccountName = `${this.payBankList[key].bankName}(${this.payBankList[key].accountNum})`
        } else if (this.picker.formKey == 'saleContractCustName') {
          this.form.saleContractCustName = this.saleContractCustOptions[key].execCustomerName
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
        }
      }
      console.log(this.form)
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    showCalendar(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datePicker.formKey = type
      if (type === 'executionTime' || type === 'zxTime') {
        this.datePicker.type = 'range'
      } else {
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      if (this.index || this.index == 0) {
        if (this.datePicker.formKey === 'payTime') {
          this.form.contPayAgreeList[this.index][this.datePicker.formKey] = this.formatDate(date)
        } else if (this.datePicker.formKey === 'zxTime') {
          const [start, end] = date
          this.pointList[this.index].startTime = this.formatDate(start)
          this.pointList[this.index].endTime = this.formatDate(end)
          this.pointList[this.index].zxTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        }
      } else {
        if (this.datePicker.formKey === 'executionTime') {
          const [start, end] = date
          this.form.startTime = this.formatDate(start)
          this.form.endTime = this.formatDate(end)
          this.form.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        } else {
          this.form[this.datePicker.formKey] = this.formatDate(date)
        }
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    async showTreeSelect(item) {
      this.typeTree = item
      if (item == 'mediaLocation') {
        this.mediaSelect = true
        this.mediaActiveIds = []
        this.form.mediaLocationNames = ''
        this.form.mediaLocationName = ''
        // console.log(this.mediaActiveIds)
        if (this.options.mediaLocationOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 2 }).then(res => {
            this.options.mediaLocationOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.treeItems = this.options.mediaLocationOptions.map(item => {
          return {
            id: item.deliveryLinkId,
            text: item.deliveryLinkName,
            children: item.children ? item.children.map(item => {
              return {
                id: item.deliveryLinkId,
                text: item.deliveryLinkName,
                disabled: false
              }
            }) : [],
            disabled: false
          }
        })
      } else if (item == 'deliveryLink') {
        this.deliverySelect = true
        this.deliveryActiveIds = []
        this.form.deliveryLinkNames = ''
        this.form.deliveryLinkName = ''
        if (this.options.deliveryLinkOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 1 }).then(res => {
            this.options.deliveryLinkOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.treeItems = this.options.deliveryLinkOptions.map(item => {
          return {
            id: item.deliveryLinkId,
            text: item.deliveryLinkName,
            children: item.children ? item.children.map(item => {
              return {
                id: item.deliveryLinkId,
                text: item.deliveryLinkName,
                disabled: false
              }
            }) : [],
            disabled: false
          }
        })
      }
    },
    chooseTree(data) {
      if (this.typeTree == 'mediaLocation') {
        if (this.mediaActiveIds.length > 0) {
          this.treeItems.map((res, index) => {
            res.disabled = true
            if (this.treeActiveIndex == index) {
              this.treeItems[this.treeActiveIndex].disabled = false
            }
          })
        } else {
          this.treeItems.map((res) => {
            res.disabled = false
          })
        }
        const arr = []
        const arr2 = []
        this.treeItems[this.treeActiveIndex].children.map((res) => {
          if (this.mediaActiveIds.length > 0) {
            this.mediaActiveIds.map((item) => {
              if (res.id == item) {
                arr.push(this.treeItems[this.treeActiveIndex].text + '/' + res.text)
                arr2.push(res.text)
              }
            })
          }
        })
        this.form.mediaLocationIds = this.mediaActiveIds.join(',')
        this.form.mediaLocationNames = arr.join(',')
        this.form.mediaLocationName = arr2.join(',')
      } else if (this.typeTree == 'deliveryLink') {
        const arr = []
        const arr2 = []
        this.treeItems.map(res => {
          res.children.map(item => {
            if (this.deliveryActiveIds.length > 0) {
              this.deliveryActiveIds.map((item2) => {
                if (item.id == item2) {
                  arr.push(res.text + '/' + item.text)
                  arr2.push(item.text)
                }
              })
            }
          })
        })
        this.form.deliveryLinkIds = this.deliveryActiveIds.join(',')
        this.form.deliveryLinkNames = arr.join(',')
        this.form.deliveryLinkName = arr2.join(',')
      }
    },
    showCustList() {
      this.selectCustshow = true
    },
    handleCancel() {
      this.selectCustshow = false
    },
    selectBeforeClose(val) {
      this.form.custId = val.custId
      this.form.custName = val.custName
      this.selectCustshow = false
      this.form.businessTypeName = null
      this.form.businessTypeId = null
    },
    showContractList() {
      this.selectContshow = true
    },
    handleContCancel() {
      this.selectContshow = false
    },
    selectContBeforeClose(val) {
      this.form.saleContractId = val.contractId
      this.form.saleContractName = val.contractName
      this.form.saleContractCustName = ''
      if (val.custSource == 1) {
        // 直客
        this.saleContractCustOptions = []
        this.form.saleContractCustName = val.custName
      } else if (val.custSource == 2) {
        // 渠道
        purchase.getSaleContractCustName({ contractId: val.contractId }).then(res => {
          if (res.code == 200) {
            this.saleContractCustOptions = res.data
          } else {
            Toast.fail(res.msg)
          }
        })
      }
      this.selectContshow = false
    },
    getIndex(index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
    },
    // 返回布尔值
    beforeRead(file) {
      console.log(this.form.fileList[this.index].fileType)
      let fileArr = []
      if (this.form.fileList[this.index].fileType == 10) {
        fileArr = ['image/png', 'image/jpg', 'image/jpeg']
        if (!fileArr.some((item) => { return file.type === item })) {
          Toast('请上传格式为 png/jpg/jpeg 的图片')
          return false
        }
        return true
      } else {
        fileArr = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
        if (!fileArr.some((item) => { return file.type === item })) {
          Toast('请上传格式为 pdf/word 的文件')
          return false
        }
        return true
      }
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    // handleContractRemove(file) {
    //   let picture = this.form.contractImg;
    //   if (picture.indexOf(file.url) == 0) {
    //     if (picture.indexOf(",") == -1) {
    //       picture = null;
    //     } else {
    //       picture = picture.replace(file.url + ",", "");
    //     }
    //   } else {
    //     picture = picture.replace("," + file.url, "");
    //   }
    //   this.form.contractImg = picture;
    //   this.pictureList = [];
    //   if (this.form.contractImg != null && this.form.contractImg.length > 0) {
    //     let payCaptures = this.form.contractImg.split(",");
    //     payCaptures.forEach((element) => {
    //       this.pictureList.push({
    //         url: element,
    //       });
    //     });
    //   }
    // },
    async uploadContractPictureFiles(file) {
      // this.form.fileName = file.file.name
      // if(this.index || this.index == 0){
      //   this.form.fileList[this.index].fileName = file.file.name
      // }
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)

      await newContract.uploadContractFile(formData)
        .then((res) => {
          // console.log("_RequestUploads_", res);
          if (res.code === 200) {
            // this.form.contractImg = res.url;
            // let picture = this.form.contractImg;
            // if (picture != null && picture.length > 0) {
            //   picture += "," + res.url;
            // } else {
            //   picture = res.url;
            // }
            // this.form.contractImg = picture;
            // let payCaptures = this.form.contractImg.split(",");
            // this.pictureList = [];
            // payCaptures.forEach((element) => {
            //   this.pictureList.push({
            //     url: element,
            //   });
            // });
            this.form.fileList[this.index].fileName = file.file.name
            this.form.fileList[this.index].url = res.url
            Toast.success(res.msg)
          } else {
            Toast.fail('res.msg')
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    viewFileTip() {
      this.showFileTip = true
    },
    addPoint() {
      const peo = {
        contractId: this.form.contractId,
        percentage: '',
        useMoney: '',
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        zxTime: this.form.executionTime
      }
      this.pointList.push(peo)
      const res = this.activeNamesP.some(item => {
        return this.pointList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.pointList.length - 1)
      }
    },
    // deletePoint
    async deletePoint(item) {
      if (this.pointList[item].returnPointId) {
        const res = await newContract.deleteRebate(this.pointList[item].returnPointId)
        if (res.code === 200) {
          await Toast.success('删除成功')
        }
        await this.pointList.splice(item, 1)
      } else {
        await this.pointList.splice(item, 1)
      }
    },
    addEnclosure() {
      const peo = {
        contractId: this.form.contractId,
        title: '',
        amount: '',
        fileType: '1',
        fileTypeName: '合同附件',
        fileDesc: '',
        url: ''
      }
      this.form.fileList.push(peo)
      const res = this.activeNamesC.some(item => {
        return this.form.fileList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesC.push(this.form.fileList.length - 1)
      }
    },
    async deleteE(item) {
      if (this.form.fileList[item].id) {
        const res = await newContract.deleteContractFile(this.form.fileList[item].id)
        if (res.code === 200) {
          await Toast.success('删除成功')
        }
        await this.form.fileList.splice(item, 1)
      } else {
        await this.form.fileList.splice(item, 1)
      }
    },
    addPayment() {
      const peo = {
        contractId: this.form.contractId,
        openName: '',
        openRow: '',
        companyAccount: '',
        advancesMoney: '',
        payTime: ''
      }
      this.form.contPayAgreeList.push(peo)
      const res = this.activeNames.some(item => {
        return this.form.contPayAgreeList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.form.contPayAgreeList.length - 1)
      }
    },
    async deleteT(item) {
      if (this.form.contPayAgreeList[item].payAgreeId) {
        const res = await purchase.deleteSaleAgree(this.form.contPayAgreeList[item].payAgreeId)
        if (res.code === 200) {
          await Toast.success('删除成功')
        }
        await this.form.contPayAgreeList.splice(item, 1)
      } else {
        await this.form.contPayAgreeList.splice(item, 1)
      }
      // const res = await newContract.deletePayAgree(this.form.contPayAgreeList[item].payAgreeId)
      // if (res.code === 200) {
      //   await Toast.success('删除成功')
      // }
      // await this.form.contPayAgreeList.splice(item, 1)
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    addBo() {
      // this.$router.push({
      //   path: '/scrm/custBo/add'
      // })
      this.add_show = true
    },
    handleAddBoCancel() {
      this.add_show = false
    },
    // 添加合同
    async addBoBeforeClose(val) {
      if (!val) { this.handleAddBoCancel(); return }
      this.form.boId = val.boId
      this.form.boName = val.boName
      this.form.businessTypeName = val.businessTypeName
      this.form.custId = val.custId
      this.form.custName = val.custName
      this.form.contractName = val.boName
      this.form.businessTypeId = val.businessTypeId
      const name = this.form.businessTypeName.split('/')
      if (name[0] == '销售' && name[1] == '数字技术类') {
        this.isVendite = false
        this.form.frameType = '1'
        this.form.payType = '1'
        this.form.custSource = null
        this.form.payCycle = null
        // this.form.advancesCycle=null
        this.form.creditCycleType = null
        this.form.creditCycleValue = null
        this.form.collectionPeriod = null
        this.form.creditMoney = null
        this.form.mediaType = null
        this.form.cooperationPolicy = null
        this.form.operationMode = null
      } else {
        this.isVendite = true
        this.form.custSource = '1'
      }
      if (name[0] != '销售') {
        // this.isMarketing=true
      }
      // this.getContCount()
      this.add_show = false
      // await this.queryCustList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.pageBox{
  padding-bottom: 200px;
  .radioGroup{
    margin-top: 20px;
  }
  .bottomBtn{
    height: 130px;
    width: 100%;
    padding-top: 10px;
    background-color: #fff;
    position: fixed;
    bottom: calc(100px + env(safe-area-inset-bottom));
    .remark{
      text-align: center;
      font-size: 14px;
      color: #ee0a24;
    }
    .btnGroup{
      margin: 0;
      display: flex;
      align-items: center;
    }
  }
  .topBtn{
    margin: 0 auto;
    margin-bottom: 20px;
    width: 80%;
  }
}
.van-form {
  margin-bottom: 50px;
  .attachment_link{
    padding: 10px 20px 0 0;
    text-align: right;
  }
}
.van-cell__value {
  min-width: 68%; //可根据自己需求设定值
  // text-align: left;
}
.dayuxiaoyufu{
  margin-left: 40px;
}
// /deep/ .van-field__label {
//   color: #333;
//   .ft(28);
// }
// // /deep/.van-field__control[disabled] {
// //   color: #000;
// //   opacity: 1;
// //   -webkit-text-fill-color: #000; // ios 和 安卓9.0 必须添加此属性，才会生效
// //   -webkit-opacity: 1;
// // }
// /deep/.van-field__control{
//   .ft(26);
//   color: #666666;
// }
// /deep/ .van-field__control::-webkit-input-placeholder {
//   // color: #666666;
//   .ft(26);
// }
.tagArr{
  padding: 0px 10px 10px 10px;
  /deep/.van-tag{
    margin-left: 10px;
  }
}
/deep/.van-sidebar-item--select::before{
  background-color: #1989fa;
}
/deep/.van-tree-select__item--active {
    color: #1989fa;
}
.notice_bar{
  height: 60px;
  font-size: 25px
}
.file_tip{
  padding: 5px 20px;
  min-height: 600px;
  font-size: 28px;
  line-height: 50px;
  div{
    font-weight: bold;
  }
}
</style>
